/*
 * bpmbuild-uat-ds.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StripeCustomerEventBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./StripeCustomerEventBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildUatDsappspotcom) {
      root.BpmbuildUatDsappspotcom = {};
    }
    root.BpmbuildUatDsappspotcom.StripeCustomerEventBean = factory(root.BpmbuildUatDsappspotcom.ApiClient, root.BpmbuildUatDsappspotcom.StripeCustomerEventBean);
  }
}(this, function(ApiClient, StripeCustomerEventBean) {
  'use strict';

  /**
   * The StripeCustomerEventBean model module.
   * @module model/StripeCustomerEventBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>StripeCustomerEventBean</code>.
   * @alias module:model/StripeCustomerEventBean
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>StripeCustomerEventBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StripeCustomerEventBean} obj Optional instance to populate.
   * @return {module:model/StripeCustomerEventBean} The populated <code>StripeCustomerEventBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('apiVersion'))
        obj.apiVersion = ApiClient.convertToType(data['apiVersion'], 'String');
      if (data.hasOwnProperty('beanInstance'))
        obj.beanInstance = StripeCustomerEventBean.constructFromObject(data['beanInstance']);
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'Date');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('liveMode'))
        obj.liveMode = ApiClient.convertToType(data['liveMode'], 'Boolean');
      if (data.hasOwnProperty('pendingWebhooks'))
        obj.pendingWebhooks = ApiClient.convertToType(data['pendingWebhooks'], 'Number');
      if (data.hasOwnProperty('request'))
        obj.request = ApiClient.convertToType(data['request'], 'String');
      if (data.hasOwnProperty('stripeEventId'))
        obj.stripeEventId = ApiClient.convertToType(data['stripeEventId'], 'String');
      if (data.hasOwnProperty('stripeType'))
        obj.stripeType = ApiClient.convertToType(data['stripeType'], 'String');
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
    }
    return obj;
  }

  /**
   * @member {String} apiVersion
   */
  exports.prototype.apiVersion = undefined;

  /**
   * @member {module:model/StripeCustomerEventBean} beanInstance
   */
  exports.prototype.beanInstance = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {Date} created
   */
  exports.prototype.created = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {Boolean} liveMode
   */
  exports.prototype.liveMode = undefined;

  /**
   * @member {Number} pendingWebhooks
   */
  exports.prototype.pendingWebhooks = undefined;

  /**
   * @member {String} request
   */
  exports.prototype.request = undefined;

  /**
   * @member {String} stripeEventId
   */
  exports.prototype.stripeEventId = undefined;

  /**
   * @member {String} stripeType
   */
  exports.prototype.stripeType = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsUatds/src/model/StripeCustomerEventBean.js